<!-- <div class=" row">
    <div class=" row header">
        <a><img src="assets/Logo.jpg"></a>
    </div>
     
  
    video confernece 
    <div class="col-md">
        <div class="row">
            <div class="video">
        
                    <video #local autoplay class="localparticipant">
                    </video>
                     <video #remote *ngIf="participantCount >0" class="remoteparticipant">
                     </video>
                     <div #remote *ngIf="isAlone">
                          <p>please wait for doctor</p>
                    </div>    
        Tracks
        <div class="row">
            <div *ngIf="activeRoom" class="text-center button">
                <button type="button" id="audioOn" (click)="getInputs('audioOff')" *ngIf="isAudio">
                    <i class="bi bi-mic"></i>
                </button>
                <button type="button" id="audioOff" (click)="getInputs('audioOn')" *ngIf="!isAudio">
                    <i class="bi bi-mic-mute"></i>
                </button>
                <button type="button" id="videoOn" (click)="getInputs('videoOn')" *ngIf="isVideo">
                    <i class="bi bi-camera-video"></i>
                </button>
                <button type="button" id="videoOff" (click)="getInputs('videoOff')" *ngIf="!isVideo">
                    <i class="bi bi-camera-video-off"></i>
                </button>
                <button class="iconClr" (click)="onLeaveRoom(true)"><i class="bi bi-telephone-x-fill"></i>
                </button>
            </div>
        </div>

    </div>
</div> -->


<div class="container main">
    <div class="row">
        <div class='col-lg-12 col-md-12 col-xs-12 room'>
            <!-- <p class="p">Room ID : {{room['roomName']}}</p> -->
        </div>
        <div class='col-lg-12 col-md-12 col-xs-12'>
            <div class="video">
                <!-- <div class="video1"  #remote *ngIf="participantCount > 0" style="background: red;"></div>
                    <div class="video2"  #local style="background: blue;"></div> -->
                <span class="logo"><img src="../../../assets/Logo.jpg" alt="" /></span>
                
                <video #local autoplay class=" video2">
                </video>
                <div class="video-big">
                    <video #remote autoplay class=" video1" *ngIf="participantCount > 0">
                    </video>
                </div>
                <!-- <video id="tempVideo"  *ngIf="isAlone" [ngClass]="participantCount > 0? 'false':'video3'" >
                       
                    </video> -->

                <p class="overlay" *ngIf="isAlone">
                  {{participantName =='member'?'Doctor':'Patient'}} will join soon
                </p>

            </div>
            <!-- sticky notes -->
            <ng-container *ngIf="showNote">
            <div class="container pp">
                <div class="row pp-header">
                    <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                        <span class="pp-ht">Prescription/Notes</span>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div class="glyphicon glyphicon-remove pp-close" (click)="showNote =false">&nbsp;</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <textarea class="notes" name="textarea" id="textarea" [(ngModel)]="notes" ></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-btn">
                        <input type="button" name="button" id="button" value="Save" (click)="noteInfo({appointmetId:doctorappoint_id,note:notes})">
                    
                    </div>
                </div>
            </div>
            </ng-container>
            <!-- sticky notes -->

        </div>

        <div class='col-lg-12 col-md-12 col-xs-12 actions'>
            <div class="bb">
                <button type="button" id="audioOn" (click)="getInputs('audioOff')" *ngIf="isAudio">
                    <i class="bi bi-mic"></i>
                </button>
                <button type="button" id="audioOff" (click)="getInputs('audioOn')" *ngIf="!isAudio">
                    <i class="bi bi-mic-mute"></i>
                </button>
                <button type="button" id="videoOn" (click)="getInputs('videoOn')" *ngIf="isVideo">
                    <i class="bi bi-camera-video"></i>
                </button>
                <button type="button" id="videoOff" (click)="getInputs('videoOff')" *ngIf="!isVideo">
                    <i class="bi bi-camera-video-off"></i>
                </button>
                <button type="button" class="iconClr" (click)="onLeaveRoom(true)"><i class="bi bi-telephone-x-fill"></i>
                </button>
                <input type="button" name="button" id="button" class="notes-btn" value="Notes" *ngIf="participantName =='doctor'" (click)="openNote()">
            </div>
        </div>
    </div>
</div>


<!-- <div class="bb"><button type="button"><i class="fa fa-video-camera" aria-hidden="true"></i></button>
    <button type="button"><i class="fa fa-microphone"></i></button>
    <button type="button"><i class="fa fa-times" aria-hidden="true"></i></button>
</div> -->